import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hierarchyTranslate',
  standalone: true
})
export class HierarchyTranslatePipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'region':
        return $localize`Region`;

      case 'company':
        return $localize`Company`;

      case 'site':
        return $localize`Site`;

      case 'sublocation':
        return $localize`Sub-Location`;

      case 'asset':
        return $localize`Asset`;

      case 'component':
        return $localize`Monitoring Point`;

      case 'monitoring point':
        return $localize`Monitoring Point`;

      case 'site Counts':
        return $localize`Site Counts`;

      case 'sublocation Counts':
        return $localize`Sub-Location Counts`;

      case 'asset Counts':
        return $localize`Asset Counts`;

      default:
        return '';
    }
  }
}
